module.exports = __webpack_public_path__ + "fonts/iconfont.18b07271.ttf";